{
  "login": {
    "title": "Sign in to your account",
    "emailLabel": "Email address",
    "emailPlaceholder": "you@example.com",
    "passwordLabel": "Password",
    "passwordPlaceholder": "••••••••",
    "forgotPassword": "Forgot password?",
    "submit": "Sign in",
    "submitting": "Signing in…",
    "errors": {
      "invalidCredentials": "Invalid credentials. Please check your email and password.",
      "accountInactive": "Your account is inactive. Please contact your administrator.",
      "unexpected": "An unexpected error occurred. Please try again."
    }
  },
  "forgotPassword": {
    "title": "Reset your password",
    "successTitle": "Check your email",
    "description": "Enter your email address and we will send you a link to reset your password.",
    "emailLabel": "Email address",
    "submit": "Send reset link",
    "submitting": "Sending…",
    "backToSignIn": "Back to sign in",
    "genericError": "Something went wrong. Please try again.",
    "successMessage": "If an account exists for {{email}}, you will receive a password reset link shortly."
  },
  "resetPassword": {
    "title": "Set a new password",
    "newPasswordLabel": "New password",
    "confirmPasswordLabel": "Confirm new password",
    "submit": "Reset password",
    "submitting": "Resetting…",
    "errors": {
      "passwordMismatch": "Passwords do not match.",
      "invalidLink": "Invalid or expired reset link. Please request a new one.",
      "expiredLink": "This reset link is invalid or has expired.",
      "requestNewLink": "Request a new link"
    },
    "success": "Password reset successfully. Please sign in."
  },
  "changePassword": {
    "title": "Change password",
    "currentPasswordLabel": "Current password",
    "newPasswordLabel": "New password",
    "confirmPasswordLabel": "Confirm new password",
    "newPasswordPlaceholder": "Min 8 characters",
    "confirmPasswordPlaceholder": "Min 8 characters",
    "submit": "Change password",
    "submitting": "Saving…",
    "errors": {
      "currentPasswordIncorrect": "Current password is incorrect.",
      "tooShort": "New password must be at least 8 characters.",
      "passwordMismatch": "Passwords do not match.",
      "genericFailed": "Failed to change password. Please try again."
    },
    "success": "Password changed successfully."
  }
}
